import { usePublicSettings } from "@/hooks/useSettings";

// Client-side read of the Dojo Core plugin switchboard. Reads the resolved
// plugin list from public settings so the Core can gate navigation while the
// underlying routes stay live (per product decision).
export function usePlugins() {
  const { data } = usePublicSettings();
  const list = data?.plugins || [];
  const map = {};
  for (const p of list) map[p.id] = p;

  // Fail-open: unknown/not-yet-loaded plugins are treated as enabled so nav
  // never disappears due to a transient fetch state or an older backend.
  const isPluginEnabled = (id) => (map[id] ? !!map[id].enabled : true);

  return { plugins: list, isPluginEnabled };
}
